import { Link, useLocation } from 'react-router-dom';

interface Crumb {
  label: string;
  href?: string;
}

const nameMap: Record<string, string> = {
  category: '分类浏览',
  illustration: '插画作品',
  comic: '漫画连载',
  doujin: '同人创作',
  cosplay: 'Cosplay',
  voice: '声优配音',
  animation: '动画短片',
  article: '文章详情',
  about: '关于我们',
};

function getBreadcrumbs(pathname: string): Crumb[] {
  const crumbs: Crumb[] = [{ label: '首页', href: '/' }];
  const segments = pathname.split('/').filter(Boolean);

  if (segments.length === 0) return crumbs;

  let accumulatedPath = '';
  for (const segment of segments) {
    accumulatedPath += `/${segment}`;
    const label = nameMap[segment] || decodeURIComponent(segment);
    crumbs.push({ label, href: accumulatedPath });
  }

  return crumbs;
}

export default function Breadcrumb() {
  const location = useLocation();
  const crumbs = getBreadcrumbs(location.pathname);

  return (
    <nav aria-label="面包屑导航" className="w-full px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <ol className="flex items-center gap-2 py-3 text-sm flex-wrap">
          {crumbs.map((crumb, index) => (
            <li key={crumb.href || index} className="flex items-center gap-2">
              {index > 0 && (
                <i className="ri-arrow-right-s-line text-foreground-400 text-xs"></i>
              )}
              {index === crumbs.length - 1 ? (
                <span className="text-foreground-500 font-medium">{crumb.label}</span>
              ) : (
                <Link
                  to={crumb.href || '/'}
                  className="text-foreground-400 hover:text-primary-500 transition-colors duration-200"
                >
                  {crumb.label}
                </Link>
              )}
            </li>
          ))}
        </ol>
      </div>
    </nav>
  );
}